const Methods = {
  getRows(rows) {
    let index = 0;
    const toSearch = Object.entries(rows).map((row) => {
      const response = { ...row[1][0], index: index, numberLot: row[0] };
      index++;
      return response;
    });

    return toSearch;
  },

  totalRegister(rows) {
    if (this.searchQuery === '') {
      this.pagination.total = this.getRows(rows).length;
    }
    return this.pagination.total;
  },

  toRows(rows) {
    let highBound = this.from + this.pagination.perPage;
    const total = this.totalRegister(rows);
    if (total < highBound) {
      highBound = total;
    }
    return highBound;
  },

  queriedDataRows(rows) {
    let result = this.getRows(rows);
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;
    return result.slice(this.from, this.toRows(rows));
  },
};

export default { Methods };
